<script lang="ts">
	import { blo } from 'blo';

	import { CATEGORY_MAP , CATEGORY_MAP_CHIPNET } from '@fbch/lib';
	import FbchIcon from './FbchIcon.svelte';

	let { category, size=64, isMainnet=true } = $props();

	let FIRST_CLASS = new Map([
		['242f6ecedb404c743477e35b09733a56cacae34f3109d5cee1cbc1d5630affd7', '/badger.svg'],
		['7003b9e854d2abc855b2c20c9734c3dfe4ec3a4de573f7ebb9ce1be527a5bb36', '/tBADGER.svg'],
		['7fe0cd5197494e47ade81eb164dcdbd51859ffbe581fe4a818085d56b2f3062c', '/SEQUIN.svg'],
		['8214f234225e5f555663290e0fb7b7b607bf0778221e6da97248bf020306831b', '/tSEQUIN.svg'],
		['c7ea26912c147b521ad956cf64461d844c3239d382ac6f7072dc43725247dc76', '/BPTS.svg'],
		['10608586e070bbea7142435775f79161751972f180f64752bae974dbe023ebc3', '/tBPTS.svg'],
		['53bd86e3f123918d2d7040449f88f7ed1bbddc309b66f2ac67cd429278f5ea58', '/PHOTON.svg'],
		['29972959d6f0dc766cdcb81bfaf8171c5605a64dd0a81fa46080f84ac87c9bef', '/PHOTON0.svg'],
		['a852635be88f7291bc42e427b8107546f943e73636945a2f6cc9532af71896c0', '/tPHOTON.svg'],
		['bb61cd7a6c8a3a3742d965dc7ac73c1117382a5c8930b68338deb881f75c0214', '/tWBCH.svg'],
		['ff4d6e4b90aa8158d39c5dc874fd9411af1ac3b5ed6f354755e8362a0d02c6b3', '/WBCH.svg']
	]);

	let FUTURE_MAP = isMainnet ? CATEGORY_MAP : CATEGORY_MAP_CHIPNET;

	
</script>

{#if FUTURE_MAP.has(category)}
	<FbchIcon time={FUTURE_MAP.get(category)} size={size} />
{:else if FIRST_CLASS.has(category)}
	<img height={size} src={FIRST_CLASS.get(category)} alt={FIRST_CLASS.get(category)} />
{:else}
	<div class="fallback">
		<img height={size} src={blo(category, 16)} alt={category} />
	</div>
{/if}

<style>
	.fallback img {
		border-radius: 30%;
	}
	img {
		filter: drop-shadow(5px 5px 5px #b1aeaead);
	}
</style>
